import React, { Component } from 'react';
import axios from "axios";
import Modal from 'react-modal';
import ToggleButton from 'react-toggle-button'
import Moment from 'react-moment';
import { FaTimes } from 'react-icons/fa';
import { FaCheck } from 'react-icons/fa';
import renderHTML from 'react-render-html';


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)'
  }
};

Modal.setAppElement(document.getElementById('root'))

class App extends Component {

  constructor(props, context){
    super(props, context);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.AddPlayer = this.AddPlayer.bind(this);
    this.handlePlayerChangeFunc = this.handlePlayerChangeFunc.bind(this);
    this.handlePlayerStatus = this.handlePlayerStatus.bind(this);
  }

  // default State object
  state = {
    players: [],
    wagers: [],
    modalIsOpen: false
  };

  closeModal() {
    const newState = Object.assign({}, this.state, {
      players: this.state.players,
      wagers: this.state.wagers,
      modalIsOpen: false
    });
    this.setState(newState);
  }

  openModal() {
    const newState = Object.assign({}, this.state, {
      players: this.state.players,
      wagers: this.state.wagers,
      modalIsOpen: true
    });
    this.setState(newState);
  }

  componentDidMount() {
    this.getPlayers();
    this.getBets("");
  }

  AddPlayer() {
    var newPlayer=this.refs.newPlayerTXT.value;
    if (newPlayer==="")
      return;
    axios
      .get("http://sportswidgets.pro:8080/api/addplayer/" + newPlayer)
      .then(response => {
        this.getPlayers();
        this.getBets("");
      })
      .catch(error => console.log(error));
  }

  handlePlayerChangeFunc(e){
    const player=e.target.value;
    if(player !== "")
     this.getBets("/"+player);
    else
     this.getBets(player);
  }

  handlePlayerStatus(customerID,state){
    var index = this.state.players.map(function(d){
        return d.CustomerID;
    }).indexOf(customerID);
    var newplayers=this.state.players;
    newplayers[index].State=state;
    const newState = Object.assign({}, this.state, {
      players: newplayers,
      wagers: this.state.wagers,
      modalIsOpen: this.state.modalIsOpen
    });
    this.setState(newState);
    var playerState = state ? 1 : 0;
    axios
      .get("http://sportswidgets.pro:8080/api/playerstatus/" + customerID + "/" + playerState)
      .then(response => {
        this.getBets("");
      })
      .catch(error => console.log(error));

  }

  getPlayers(){
    axios
      .get("http://sportswidgets.pro:8080/api/getplayers")
      .then(response => {
        // create an array of contacts only with relevant data
        const newPlayers = response.data.data.map(c => {
          return {
            CustomerID: c.CustomerID,
            State: c.State
          };
        });

        // create a new "State" object without mutating 
        // the original State object. 
        const newStatePlayers = Object.assign({}, this.state, {
          players: newPlayers,
          wagers: [],
          modalIsOpen: this.state.modalIsOpen
        });

        // store the new state object in the component's state
        this.setState(newStatePlayers);
      })
      .catch(error => console.log(error));
  }

  getBets(player){
    axios
      .get("http://sportswidgets.pro:8080/api/getbets" + player)
      .then(response => {
        // create an array of contacts only with relevant data
        const newWagers = response.data.data.map(c => {
          return {
            TicketNumber: c.TicketNumber,
            CustomerID: c.CustomerID,
            Accepted: c.Accepted,
            Risk: c.Risk,
            ToWin: c.ToWin,
            Description: c.Description
          };
        });

        // create a new "State" object without mutating 
        // the original State object. 
        const newState = Object.assign({}, this.state, {
          players: this.state.players,
          wagers: newWagers,
          modalIsOpen: this.state.modalIsOpen
        });

        // store the new state object in the component's state
        this.setState(newState);
      })
      .catch(error => console.log(error));
  }

  
  render() {
    return (
      <div className="App">
       
       <div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Add Player"
        >
          <div>
             Player:<input type="text" id="newPlayer" ref="newPlayerTXT" name="newPlayer" defaultValue="" className="addplayer"/>
             <button onClick={this.AddPlayer}>Add</button>
          </div>
          <br/>
          <div className="row grid-header">
              <div className="col-sm-8 text-left">Player</div>
              <div className="col-sm-4 text-left">State</div>
          </div>
          {
            this.state.players.map((obj) => {
              return(
                    <div key={obj.CustomerID+"_modal"} className="row playerdata">
                      <div className="col-sm-8 text-left">{obj.CustomerID}</div>
                      <div className="col-sm-4 text-left">
                      <ToggleButton
                        inactiveLabel={<FaTimes/>}
                        activeLabel={<FaCheck/>}
                        value={obj.State}
                        onToggle={(value) => {
                          this.handlePlayerStatus(obj.CustomerID,!value);
                        }} />
                      </div>
                    </div>  
                    )
            })
          }
          <br/>
          <button onClick={this.closeModal}>Close</button>
        </Modal>
       
       </div>
        
        
        <div className="row">
          <div className="col-sm-2"><button onClick={this.openModal}>Control Players</button></div>
          <div className="col-sm-10">
           Players:&nbsp;
           <select key="playerlist" id="playerlist" onChange={this.handlePlayerChangeFunc}>
              <option key="all" value="">All</option> 
              {
                 this.state.players.filter((item) => {
                      return item.State === true;
                    }).map((obj) => {
                     return <option key={obj.CustomerID} value={obj.CustomerID}>{obj.CustomerID}</option>
                 })
              }
           </select>
        </div>
        </div>
        <div className="row grid-header">
              <div className="col-sm-2">Ticket</div>
              <div className="col-sm-2">Player</div>
              <div className="col-sm-2">Accepted</div>
              <div className="col-sm-2">Description</div>
              <div className="col-sm-2">Risk</div>
              <div className="col-sm-2">Win</div>
          </div>
          {
              this.state.wagers.map((obj) => {
                  return(
                    <div key={obj.TicketNumber+"_grid"} className="row wagerdata">
                        <div className="col-sm-2 text-center">{obj.TicketNumber}</div>
                        <div className="col-sm-2 text-center">{obj.CustomerID}</div>
                        <div className="col-sm-2 text-center">
                        <Moment parse="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss">
                          {obj.Accepted}
                        </Moment>
                        </div>
                        <div className="col-sm-2 text-left">{renderHTML(obj.Description)}</div>
                        <div className="col-sm-2 text-center">
                        {new Intl.NumberFormat('en-US', { 
                            style: 'currency', 
                            currency: 'USD' 
                        }).format(obj.Risk)}
                        </div>
                        <div className="col-sm-2 text-center">
                        {new Intl.NumberFormat('en-US', { 
                            style: 'currency', 
                            currency: 'USD' 
                        }).format(obj.ToWin)}
                        </div>
                    </div>
                  )
              })
          }
           
      </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js